<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'country.detail', params: {id: id}}">Страна</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'country.list'}">Страны</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>

          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
          <gui-input v-model="data.name" :error="dataError.name" label="Название"/>
          <gui-input v-model="data.code" :error="dataError.code" label="Код"/>
          <gui-input v-model="data.flag_code" :error="dataError.flag_code" label="Код флага"/>
          <gui-input v-model="data.phone_code" :error="dataError.phone_code" label="Код телефона"/>
          <gui-input v-model="data.sort" :error="dataError.sort" label="Сортировка"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


export default {
  data() {
    return {
      data: null,
      dataDefault: {
        name: '',
        code: '',
        flag_code: '',
        phone_code: '',
        is_active: '',
        sort: '',
      },
      dataError: {
        name: '',
        code: '',
        flag_code: '',
        phone_code: '',
        is_active: '',
        sort: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/country/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/country/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'country.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/country/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'country.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>